import { render, staticRenderFns } from "./ferienboerseEntryEditor.vue?vue&type=template&id=7c4b925d&"
import script from "./ferienboerseEntryEditor.vue?vue&type=script&lang=js&"
export * from "./ferienboerseEntryEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports